import { render, staticRenderFns } from "./OrderBill.vue?vue&type=template&id=1c9459fa&scoped=true"
import script from "./OrderBill.vue?vue&type=script&lang=js"
export * from "./OrderBill.vue?vue&type=script&lang=js"
import style0 from "./OrderBill.vue?vue&type=style&index=0&id=1c9459fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9459fa",
  null
  
)

export default component.exports